module.exports = __webpack_public_path__ + "static/media/domicilio.02e3e2b0.svg";